<template>
    <adaptive-modal
        name="activity-log-modal"
        :hide-action-buttons="true"
        width="800"
        @before-open="beforeOpen"
    >
        <div v-if="activityLog">
            <div class="grid">
                <div class="column w-1/2">
                    <h1 class="headline-md">Gamla värden</h1>
                    <table
                        v-if="Object.keys(activityLog.old).length > 0"
                        class="table condensed striped"
                    >
                        <tbody>
                            <tr v-for="attribute in activityLog.old">
                                <td>{{ attribute.name }}</td>
                                <td>{{ truncateIfLong(attribute.value) }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <ul v-else-if="activityLog.old_values" class="list-reset">
                        <li v-for="value in activityLog.old_values" class="mb-sm">
                            <font-awesome-icon icon="minus" class="mr-sm" /> {{ value }}
                        </li>
                    </ul>
                    <em v-else>
                        Inga gamla värden.
                    </em>
                </div>
                <div class="column w-1/2">
                    <h1 class="headline-md">Nya värden</h1>
                    <table
                        v-if="Object.keys(activityLog.attributes).length > 0"
                        class="table condensed striped"
                    >
                        <tbody>
                            <tr v-for="attribute in activityLog.attributes">
                                <td>{{ attribute.name }}</td>
                                <td>{{ truncateIfLong(attribute.value) }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <ul v-else-if="activityLog.values" class="list-reset">
                        <li v-for="value in activityLog.values" class="mb-sm">
                            <font-awesome-icon icon="plus" class="mr-sm" /> {{ value }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div v-else>Laddar händelse...</div>

        <button
            type="button"
            class="btn is-ghost btn-lg mt-2xl"
            @click="hide"
        >
            Stäng
        </button>
    </adaptive-modal>
</template>
<script>
    export default {
        data() {
            return {
                activityLog: null,
            };
        },
        methods: {
            truncateIfLong(value) {
                if (value && value.length > 300) {
                    return value.substring(0, 300) + '...';
                } else {
                    return value || '-';
                }
            },
            beforeOpen(event) {
                this.activityLog = null;
                axios.get(route('api.activityLogs.show', event.params.id))
                    .then(response => {
                        this.activityLog = response.data;
                    });
            },
            hide() {
                this.$modal.hide('activity-log-modal');
            },
        },
    };
</script>